<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('settings/settings:meta.meta') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:meta.meta') })"
            icon2="delete"
            @clickedButton2="deleteMeta"
            icon="edit"
            @updateTableData="updateTable"
            @clickedButton1="editMeta"
            @clickedAddButton="editMeta"
            :addBtn="true"
            sortBy="name"
        />

      </v-col>
    </v-row>

    <MetaForm
        @updateTable="updateTableAfterManipulation"
        ref="metaForm" />

  </div>
</template>

<script>
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import MetaForm from '@/modules/settings/views/settings/meta/MetaForm.vue';
import MetaService from '@/modules/settings/services/meta-service';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import Meta from '@/modules/settings/data/meta';

export default {
  components: {
    MetaForm,
    DataTablePaginated
  },
  data() {
    return {
      metas: {},
      countries: []
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:color'), value: 'color'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      MetaService.readAllMetasPaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Meta);
            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:meta.meta')}));
          }
      )
    },
    deleteMeta(meta) {
      MetaService.deleteMeta(meta.id,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('settings/settings:meta.meta')}));
          this.updateTableAfterManipulation();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('settings/settings:meta.meta')}));
        }
      );
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editMeta(meta) {
      this.$refs.metaForm.initialization(meta);
    }
  }
}
</script>